define(function (require) {

    var StatusWidgetViewController = require('web-agent-viewControllers/StatusWidgetViewController');
    var AccountWidgetViewController = require('web-agent-viewControllers/AccountWidgetViewController');
    var LEMenuItemsViewController = require('web-agent-viewControllers/LEMenuItemsViewController');

    // todo - require it!
    window.LE = window.LE || {};

    var ViewController = require('web-agent-framework/ViewController');
    var agentLEManager = require('web-agent-utils/agentLEManager');

    var HeaderViewController = ViewController.extend({
        ControllerName: "HeaderViewController",

        LPViewMap: {
            statusListContainer: 'top-level-menu-status-list-container'
        },

        LPClassesMap: {
            hide: 'hide'
        },

        initialize: function () {
        },

        events: function () {
            this.bindModel({modelPath: "agent.status", callback: this.statusChanged});
        },

        render: function () {
        }
    });

    HeaderViewController.prototype.createLiveEngageStatusWidget = function () {
        if (!this.statusWidgetVC) {
            this.statusWidgetVC = new LEMenuItemsViewController({
                modelController: this.modelController
            });
        }
    };

    HeaderViewController.prototype.createStatusWidget = function () {
        if (!this.statusWidgetVC) {
            this.statusWidgetVC = new StatusWidgetViewController({
                modelController: this.modelController,
                templateFile: "LP_status_widget.html",
                hidden: true
            });

            var header = document.getElementById("lpview_header"); // TODO: This is temporal, it will be changed to the real hook for Live Engage
            this.addViewController({viewController: this.statusWidgetVC, target: header});
            header = null;
        }
    };

    HeaderViewController.prototype.createAccountViewController = function () {
        if (!this.accountVC) {
            this.accountVC = new AccountWidgetViewController({
                modelController: this.modelController,
                templateFile: "LP_account_widget.html",
                hidden: true
            });

            var header = document.getElementById("lpview_header"); // TODO: This is temporal, it will be changed to the real hook for Live Engage
            this.addViewController({viewController: this.accountVC, target: header});
            header = null;
        }
    };

    HeaderViewController.prototype.adjustStatusWidgetContainer = function () {
        var trayContainer = document.getElementsByClassName(this.LPViewMap.statusListContainer);
        if (trayContainer && trayContainer[0]) {
            if (trayContainer[0].classList) { // classList supported only from IE10, in order to support ie9 we need to use className
                trayContainer[0].classList.add(this.LPClassesMap.hide);
            } else {
                trayContainer[0].className += " " + this.LPClassesMap.hide;
            }
        }
    };

    HeaderViewController.prototype.statusChanged = function (data) {
        if (data.newValue == 'loggedIn') {
            if (agentLEManager.isInLE()) {
                this.createLiveEngageStatusWidget();
            } else {
                this.createAccountViewController();
                this.createStatusWidget();
            }
        } else {
            if (!agentLEManager.isInLE()) { // On LiveEngage we do not kill the status widgets VC.
                this.statusWidgetVC = null;
            }
            this.accountVC = null;
        }
    };

    return HeaderViewController;

});
